import { Component , Vue } from 'vue-property-decorator';
import { HomeworksService } from '@/homework/services/homeworks.service';
import KEYS from '@/values/keys';
import { _HOMEWORKS_STORE, HOMEWORKS_EVENTS } from '@/homework/values/homeworks.values';

@Component({})
export default class CourseWhiteboardResponseMixin extends Vue {

  private board: string = '';
  private boardGroupHash: string = '';
  private isLoading: boolean = true;

  get numberPages() : number {
    return this.$store.state.HomeworksStore.numberPages;
  }

  public callPdf(homeworkId : number, studentId : number){
    this.isLoading = true;
    HomeworksService.obtainWhiteboardHomeworkFeedbackHash(homeworkId)
        .then(response => {         
            this.boardGroupHash = response.boardGroupHash;
            // this.board = await this.getBoardUrl(response);  // moved to ed-whiteboard
            this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_NUMBER_PAGES, response.numberPages);
            this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.ADD_BOARD_HOMEWORK_HASH_USERS, {boardGroupHash: this.boardGroupHash, homeworkId: homeworkId, users: []});
            this.$edEventBus.$emit(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS, studentId);
        })
        .catch(error => {
          let errorDefaultDetail = {
            title: this.$i18n.t('courses.errors.errorTitle'),
            body: this.$i18n.t('courses.errors.errorOpenWhiteboardObject'),
            type: KEYS.EVENT_TYPES.DANGER,
            action: () => { 
              this.$EdModal.closeModal();
            }
          };
  
          if(error && error.status === 400){
            errorDefaultDetail.body = this.$i18n.t('courses.errors.errorNotFoundOpenWhiteboardObject');
            errorDefaultDetail.action = () => { 
              this.$EdModal.closeModal();
              this.$edEventBus.$emit(HOMEWORKS_EVENTS.RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET);
              this.$edEventBus.$emit(HOMEWORKS_EVENTS.RELOAD_SECTION_TEACHER_WIDGET);
            };
          }
          
          this.$EdModal.createMessageModal(errorDefaultDetail);
        }).finally(() => this.isLoading = false);
  }

  public cancelLoading(): void{
    this.isLoading = false;
  }

}